import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { resolveTheme, applyThemeAttributes } from './resolveTheme';
import { ensureNewLookFont } from './loadFont';

const darkQuery = () => (window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null);

// Called by the four staff layouts only. Unmounting (logout, switching to /agent or /portal)
// clears the attributes, so other apps in the same tab never inherit the new look.
export default function useAppearance() {
  const { user } = useAuth();
  const [prefersDark, setPrefersDark] = useState(() => !!darkQuery()?.matches);

  useEffect(() => {
    const mq = darkQuery();
    if (!mq) return undefined;
    const onChange = (e) => setPrefersDark(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const theme = resolveTheme(user?.appearance, prefersDark);

  useEffect(() => {
    const el = document.documentElement;
    if (theme) ensureNewLookFont(document);
    applyThemeAttributes(el, theme);
    return () => applyThemeAttributes(el, null);
  }, [theme]);
}
